{
	"title": "Accesso negato (403)",
	"description": "Non disponi dei diritti necessari per accedere a questa pagina. Assicurati di aver effettuato l’accesso con un account che dispone delle autorizzazioni appropriate. Anche la cancellazione dei dati del browser potrebbe risolvere il problema. Se hai ancora bisogno di accesso, contatta l’amministratore di sistema.",
	"secondaryButtonTitle": "Logout"
}
